<template>
  <div>
    <div class="dynamic-module" v-for="(question,index) in dynamicModule.questionList" :key="index">
      <div class="row">
        <div class="inner-title col-sm text-left pb-0">{{index+1}}. {{question.question}}</div>
        <!-- 
          addRowSavedAnswer -- In this specific question answers has been stored.
           savedAnswer -- In this regular answer has been stored.
        -->
        <!-- chechking the answer of specific question. If Yes or No then printing YES -->
        <div class="col-1 text-left">
          <span v-for="(Answer,index) in question.savedAnswer" :key="index">
            <span v-for="(savedAnswerObj,index2) in Answer" :key="index2">
              <span
                v-if="savedAnswerObj.keyValue == 'Yes' || savedAnswerObj.keyValue == 'No'"
              >{{savedAnswerObj.keyValue}}</span>
            </span>
          </span>
        </div>
        <!-- Question having addrow No,controlType dropdown,radio and savedanswer length equal to one-->
        <div class="col-sm text-left">
          <!-- question considerControlType equal No  -->
          <span v-if="question.considerControlType == 'N' && question.addRow =='N'">
            <span v-if="question.controlType == 'D' || question.controlType == 'R'">
              <span v-for="(savedanswer,index) in question.savedAnswer" :key="index">
                <!-- checking answer length if answer length is one than no need to use table -->
                <div v-if="savedanswer && savedanswer.length == 1" class="col-sm text-left">
                  <span v-for="(answer,index) in savedanswer" :key="index">{{answer.keyValue}}</span>
                </div>
              </span>
            </span>
          </span>
          <!-- question considerControlType equal Yes but No additonal Question case. -->
          <span
            v-if="(question.controlType == 'R' || question.controlType == 'U' || question.controlType == 'T' )
            && question.considerControlType == 'Y' 
            && question.answerResponse[0].additionalQuestions == '' && question.addRow =='N'"
          >
            <span v-for="(rowSavedAnswer,index) in question.savedAnswer" :key="index">
              <span v-for="(rowSavedAnswer,index) in rowSavedAnswer" :key="index">
                <div class="col-sm text-left" v-if="rowSavedAnswer.keyValue != 'Yes'">
                  <ul v-if="question.controlType == 'U'">
                    <li>
                      <a
                        @click="showFile(rowSavedAnswer.keyValue)"
                        href="#"
                      >{{getAttachmentName(rowSavedAnswer.keyValue)}}</a>
                    </li>
                  </ul>
                  <span v-if="question.controlType != 'U'">{{rowSavedAnswer.keyValue}}</span>
                </div>
              </span>
            </span>
          </span>
          <!-- Question have specific question if yes than print answer case -->
          <span v-for="(answer,index) in question.answerResponse" :key="index">
            <span v-for="(additionalQuestion,index2) in answer.additionalQuestions" :key="index2">
              <span
                v-if="additionalQuestion.additionalAnswerResponse && additionalQuestion.additionalAnswerResponse.length == 1"
              >
                <span v-if="answer.keyDesc == 'Yes'">
                  <!-- v-if="additionalQuestion.additionalAnswerResponse[0].controlType=='U'" -->
                  <span
                    v-for="(savedAnswers,indexAnswer) in question.addRowSavedAnswer"
                    :key="indexAnswer"
                  >
                    <span v-for="(savedAnswer,indexAnswer2) in savedAnswers" :key="indexAnswer2">
                      <span v-if="savedAnswer.controlType == 'U'">
                        <ul>
                          <li>
                            <a
                              @click="showFile(savedAnswer.keyValue)"
                              href="#"
                            >{{getAttachmentName(savedAnswer.keyValue)}}</a>
                          </li>
                        </ul>
                      </span>
                      <div v-else class="col-sm text-left">
                        <span>{{savedAnswer.keyValue}}</span>
                      </div>
                    </span>
                  </span>
                </span>
                <!-- to be added -> 2nd level of No selected -->
                <span v-if="answer.keyDesc == 'No'"></span>
              </span>
            </span>
          </span>
        </div>
      </div>
      <!-- Question having addrow equal no -->
      <div class="pb-2">
        <span v-if="question.addRow == 'N'">
          <span v-for="(Answer,index) in question.savedAnswer" :key="index">
            <span v-for="(savedAnswerObj,index1) in Answer" :key="index1">
              <span v-if="savedAnswerObj.keyValue == 'Yes'">
                <!-- checking question having specific answer if yes then checking additional question-->
                <span>
                  <span v-for="(check,i) in question.answerResponse" :key="i">
                    <span v-for="(add,index1) in check.additionalQuestions" :key="index1">
                      <!-- additional question having addrow equal no -->
                      <span v-if="add.addRow == 'N' ">
                        <span class="my-custom-scrollbar"
                          v-if="add.additionalAnswerResponse && add.additionalAnswerResponse.length > 1"
                        >
                          <!--  -->
                          <table
                            v-if="check.keyValue == 'Yes' || check.keyDesc == 'Yes'"
                            class="table table-striped mt-2"
                          >
                            <thead>
                              <tr>
                                <th
                                  v-for="(additionalAnswer,index) in add.additionalAnswerResponse"
                                  :key="index"
                                >{{additionalAnswer.displayName}}</th>
                              </tr>
                            </thead>
                            <tbody class="text-left">
                              <tr>
                                <td
                                  v-for="(answer,index) in question.addRowSavedAnswer[0]"
                                  :key="index"
                                >{{answer.keyValue}}</td>
                              </tr>
                            </tbody>
                          </table>
                        </span>
                      </span>
                      <!-- additional question having addrow equal yes. if additional answer response greater than one than putting 
                      table else no. -->
                      <div class="pb-0 my-custom-scrollbar">
                        <table
                          v-if="add.addRow == 'Y' && add.additionalAnswerResponse
                        && add.additionalAnswerResponse.length > 1 && check.keyDesc == 'Yes'"
                          class="table table-striped"
                        >
                          <thead>
                            <tr>
                              <th
                                v-for="(heading,index) in add.additionalAnswerResponse"
                                :key="index"
                              >{{heading.displayName}}</th>
                            </tr>
                          </thead>
                          <tbody class="text-left">
                            <tr v-for="(value,index) in question.addRowSavedAnswer" :key="index">
                              <td v-for="(answer,index) in value" :key="index">
                                <span v-if="answer.controlType =='U'">
                                  <a
                                    @click="showFile(answer.keyValue)"
                                    href="#"
                                  >{{getAttachmentName(answer.keyValue)}}</a>
                                </span>
                                <span
                                  v-if="answer.controlType == 'DP'"
                                >{{dateFormat(answer.keyValue)}}</span>
                                <span
                                  v-if="answer.controlType == 'T'|| answer.controlType == 'D'"
                                >{{answer.keyValue}}</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </span>
                  </span>
                </span>
              </span>
               <!-- checking question having specific answer, if No then checking additional question-->
              <span v-if="savedAnswerObj.keyValue == 'No'">
                <span v-for="(check,i) in question.answerResponse" :key="i">
                  <span v-for="(add,index1) in check.additionalQuestions" :key="index1">
                    <!-- additional question having add row equal N -->
                    <span v-if="add.addRow == 'N' ">
                      <span class="my-custom-scrollbar"
                        v-if="add.additionalAnswerResponse && add.additionalAnswerResponse.length > 1"
                      >
                        <!--  -->
                        <table
                          v-if="check.keyValue == 'No' || check.keyDesc == 'No'"
                          class="table table-striped mt-2"
                        >
                          <thead>
                            <tr>
                              <th
                                v-for="(additionalAnswer,index) in add.additionalAnswerResponse"
                                :key="index"
                              >{{additionalAnswer.displayName}}</th>
                            </tr>
                          </thead>
                          <tbody class="text-left">
                            <tr>
                              <td
                                v-for="(answer,index) in question.addRowSavedAnswer[0]"
                                :key="index"
                              >{{answer.keyValue}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </span>
                    </span>
                     <!-- additional question having add row equal Yes -->
                    <div class="pb-0 my-custom-scrollbar">
                      <table
                        v-if="add.addRow == 'Y' && add.additionalAnswerResponse
                        && add.additionalAnswerResponse.length > 1 && check.keyDesc == 'No'"
                        class="table table-striped"
                      >
                        <thead>
                          <tr>
                            <th
                              v-for="(heading,index) in add.additionalAnswerResponse"
                              :key="index"
                            >{{heading.displayName}}</th>
                          </tr>
                        </thead>
                        <tbody class="text-left">
                          <tr v-for="(value,index) in question.addRowSavedAnswer" :key="index">
                            <td v-for="(answer,index) in value" :key="index">
                              <span v-if="answer.controlType =='U'">
                                <a
                                  @click="showFile(answer.keyValue)"
                                  href="#"
                                >{{getAttachmentName(answer.keyValue)}}1</a>
                              </span>
                              <span
                                v-if="answer.controlType == 'DP'"
                              >{{dateFormat(answer.keyValue)}}</span>
                              <span
                                v-if="answer.controlType == 'T'|| answer.controlType == 'D'"
                              >{{answer.keyValue}}</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </span>
                </span>
              </span>
              <!-- Question having radio input.if '< 50%' then additional question -->
              <span v-if="savedAnswerObj.keyValue == ' < 50%'">
                <!--  -->
                <span v-for="(answer,index) in question.answerResponse" :key="index">
                  <span v-if="answer.keyDesc == ' < 50%'">
                    <span class="my-custom-scrollbar"
                      v-for="(additionalQuestion,index2) in answer.additionalQuestions"
                      :key="index2"
                    >
                      <table
                        class="table table-striped"
                        v-if="question.addRowSavedAnswer && question.addRowSavedAnswer.length > 0"
                      >
                        <thead>
                          <tr>
                            <th
                              v-for="(heading,index3) in additionalQuestion.additionalAnswerResponse"
                              :key="index3"
                            >{{heading.displayName}}</th>
                          </tr>
                        </thead>
                        <tbody class="text-left">
                          <tr v-for="(value,index) in question.addRowSavedAnswer" :key="index">
                            <td v-for="(answer,index) in value" :key="index">
                              <span v-if="answer.controlType =='U'">
                                <a
                                  @click="showFile(answer.keyValue)"
                                  href="#"
                                >{{getAttachmentName(answer.keyValue)}}</a>
                              </span>
                              <span
                                v-if="answer.controlType == 'DP'"
                              >{{dateFormat(answer.keyValue)}}</span>
                              <span
                                v-if="answer.controlType == 'T'|| answer.controlType == 'D'"
                              >{{answer.keyValue}}</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </span>
                  </span>
                </span>
              </span>
            </span>
          </span>
          <!-- Regular question having control type dropdown,text if answer response length greater than one than 
          printing as table else no. -->
          <span class="my-custom-scrollbar" v-if="question.controlType == 'D' || question.controlType == 'T'">
            <table
              v-if="question.answerResponse && question.answerResponse.length > 1 &&  question.savedAnswer[0] && question.savedAnswer[0].length > 1"
              class="table table-striped"
            >
              <thead>
                <tr>
                  <th
                    v-for="(heading,index3) in question.answerResponse"
                    :key="index3"
                  >{{heading.displayName}}</th>
                </tr>
              </thead>
              <tbody class="text-left">
                <tr v-for="(value,index) in question.savedAnswer" :key="index">
                  <td v-for="(answer,index) in value" :key="index">
                    <span v-if="answer.controlType =='U'">
                      <a
                        @click="showFile(answer.keyValue)"
                        href="#"
                      >{{getAttachmentName(answer.keyValue)}}</a>
                    </span>
                    <span v-if="answer.controlType == 'DP'">{{dateFormat(answer.keyValue)}}</span>
                    <span
                      v-if="(answer.controlType == 'T'|| answer.controlType == 'D') && answer.keyValue"
                    >{{answer.keyValue}}</span>
                    <span v-else>&nbsp; &nbsp; &nbsp; -</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </span>
        </span>
      </div>
    <!-- Question having add roww equal Yes. -->
      <div class="pb-2">
        <div class="my-custom-scrollbar" v-if="question.addRow == 'Y'">
          <!-- Printing regular answer in table if length greater than zero-->
          <table
            class="table table-striped"
            v-if="question.savedAnswer && question.savedAnswer.length > 0"
          >
            <thead>
              <tr>
                <th
                  v-for="(heading,index) in question.answerResponse"
                  :key="index"
                >{{heading.displayName}}</th>
              </tr>
            </thead>
            <tbody class="text-left">
              <tr v-for="(value,index) in question.savedAnswer" :key="index">
                <td v-for="(answer,index) in value" :key="index">
                  <span v-if="answer.controlType =='U'">
                    <a
                      @click="showFile(answer.keyValue)"
                      href="#"
                    >{{getAttachmentName(answer.keyValue)}}</a>
                  </span>
                  <span
                    v-if="answer.controlType =='T'||answer.controlType =='D'"
                  >{{answer.keyValue}}</span>
                  <span v-if="answer.controlType =='DP'">{{dateFormat(answer.keyValue)}}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <w-loadingSpinner :loadSpinner="loading" />
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import loadingSpinner from "../../widgets/LoadingSpinner";
import { PartnerService } from "../../services/partnerService";
const partnerService = new PartnerService();
export default {
  components: {
    "w-loadingSpinner": loadingSpinner
  },
  props: ["dynamicModule"],
  data() {
    return {
      loading: false,
      answer: ""
    };
  },
  methods: {
    dateFormat(date) {
      return moment(date).format("Do MMM YYYY");
    },
    showFile(documentId) {
      this.loading = true;
      partnerService
        .downLoadDocument(documentId)
        .then(res => {
          this.loading = false;
        })
        .catch(e => {});
    },
    getAttachmentName(documentId) {
      let attachmentName = "";
      attachmentName = documentId.split(/_(.+)/)[1]
        ? documentId.split(/_(.+)/)[1]
        : documentId;
      return attachmentName;
    }
  }
};
</script>
<style scoped>
.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #d0d3d6;
  background-color: #6192b1;
  position: sticky;
  color: #fff;
  text-align: left;
  width: 20%;
}
.dynamic-module {
  font-family: "Source Sans Pro", sans-serif;
}
.inner-title {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: 600;
  text-align: left;
  font-stretch: normal;
  line-height: 1.25;
  text-align: left;
  padding-bottom: 1%;
  text-align: left;
  color: #212121;
}
.my-custom-scrollbar {
  max-height: 300px;
  width: 100%;
  font-family: "Source Sans Pro", sans-serif;
  overflow: auto;
}
.my-custom-scrollbar thead th {
  position: sticky;
  top: 0;
}
</style>